import React from 'react';
import classNames from 'classnames';
import ContentParser from 'src/ui/library/ContentParser';
import Spinner from 'src/ui/library/Spinner/Spinner';

export default function CaseStatusFormDetailPres(props) {
  const { bpfStatusInfo, onFormChange, isLoading, isActive } = props;

  if (isLoading || !bpfStatusInfo)
    return (
      <div style={{ marginTop: '10%' }}>
        <Spinner size={70} />
      </div>
    );
  if (!bpfStatusInfo.pageElements)
    return (
      <div style={{ marginTop: '10%' }}>
        <Spinner size={70} />
      </div>
    );

  const formClass = classNames({
    'cases-form-detail': true,
    editmode: false,
  });

  const wrapperFormDivClass = classNames({
    'detail-body-inner': true,
  });

  const numberOfColumns = 3;

  return (
    <React.Fragment>
      <div style={{ display: isActive ? '' : 'none' }}>
        <div className={wrapperFormDivClass}>
          <section className={formClass}>
            <div className="form-parser">
              <ContentParser
                key={false}
                readOnly={true}
                data={bpfStatusInfo}
                numberOfColumns={numberOfColumns}
                showLabels={false}
                debug={false}
                onChange={onFormChange}
              />
            </div>
          </section>
        </div>
      </div>
    </React.Fragment>
  );
}
